<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-tabs v-model="activeTab" background-color="transparent" color="primary">
      <v-tab>{{ $t("subsidyMotorCatalog.tabs.variables") }}</v-tab>
      <v-tab>{{ $t("subsidyMotorCatalog.tabs.groupings") }}</v-tab>
      <v-tab>{{ $t("subsidyMotorCatalog.tabs.calculations") }}</v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <variaveis-tab
          :variaveis="variaveis"
          :loading="loadingVariaveis"
          v-bind="sharedProps"
          @refresh="refresh"
        />
      </v-tab-item>

      <v-tab-item>
        <agrupamentos-tab
          :agrupamentos="agrupamentos"
          :loading="loadingAgrupamentos"
          v-bind="sharedProps"
          @refresh="refresh"
        />
      </v-tab-item>

      <v-tab-item>
        <calculos-tab
          :calculos="calculos"
          :agrupamentos="agrupamentos"
          :variaveis="variaveis"
          :tarifas="tarifas"
          :loading="loadingCalculos"
          v-bind="sharedProps"
          @refresh="refresh"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import VariaveisTab from "./subsidioMotor/catalogo/VariaveisTab.vue";
import AgrupamentosTab from "./subsidioMotor/catalogo/AgrupamentosTab.vue";
import CalculosTab from "./subsidioMotor/catalogo/CalculosTab.vue";
import apiController from "../utils/apiController";
import {
  isFinalidadeValor,
  isFinalidadeGrandeza,
} from "../utils/subsidioFinalidadeCalculo";
import EventBus from "../utils/eventBus";

export default {
  components: {
    VariaveisTab,
    AgrupamentosTab,
    CalculosTab,
  },
  data: () => ({
    user: null,
    token: null,
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    activeTab: 0,
    variaveis: [],
    agrupamentos: [],
    calculos: [],
    tarifas: [],
    loadingVariaveis: false,
    loadingAgrupamentos: false,
    loadingCalculos: false,
  }),
  computed: {
    defaultSort() {
      return [{ value: "codigo", options: { text: this.$t("system.labels.increasing"), value: 1 } }];
    },
    sharedProps() {
      return {
        token: this.token,
        canInsert: this.canInsert,
        canEdit: this.canEdit,
        canDelete: this.canDelete,
        defaultSort: this.defaultSort,
      };
    },
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  methods: {
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: () => {
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data || [];
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/subsidio/motor/updatevariavel");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/subsidio/motor/insertvariavel");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/subsidio/motor/deletevariavel");
            this.initialize();
          },
        });
      }
    },
    async initialize() {
      await Promise.all([
        this.fetchVariaveis(),
        this.fetchAgrupamentos(),
        this.fetchCalculos(),
        this.fetchTarifas(),
      ]);
    },
    async refresh(lists) {
      const fetchers = {
        variaveis: this.fetchVariaveis,
        agrupamentos: this.fetchAgrupamentos,
        calculos: this.fetchCalculos,
      };
      for (const list of lists) {
        await fetchers[list]();
      }
    },
    async fetchVariaveis() {
      this.loadingVariaveis = true;
      try {
        const resp = await apiController.request(apiController.endpoints.subsidioMotorVariaveis, { silent: true });
        this.variaveis = Array.isArray(resp.data) ? resp.data : [];
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingVariaveis = false;
      }
    },
    async fetchAgrupamentos() {
      this.loadingAgrupamentos = true;
      try {
        const resp = await apiController.request(apiController.endpoints.subsidioMotorAgrupamentos, { silent: true });
        this.agrupamentos = Array.isArray(resp.data) ? resp.data : [];
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingAgrupamentos = false;
      }
    },
    async fetchCalculos() {
      this.loadingCalculos = true;
      try {
        const resp = await apiController.request(apiController.endpoints.subsidioMotorCalculos, { silent: true });
        const list = Array.isArray(resp.data) ? resp.data : [];
        this.calculos = list.map((c) => ({
          ...c,
          finalidadeLabel: this.finalidadeLabel(c.finalidade),
        }));
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
      } finally {
        this.loadingCalculos = false;
      }
    },
    async fetchTarifas() {
      try {
        const resp = await apiController.request(apiController.endpoints.getallTipostarifas, { silent: true });
        this.tarifas = Array.isArray(resp.data) ? resp.data : [];
      } catch (e) {
        EventBus.$emit("show-error", { error: e });
      }
    },
    finalidadeLabel(finalidade) {
      if (isFinalidadeValor(finalidade)) {
        return this.$t("subsidyMotorCatalog.purposes.contractValue");
      }
      if (isFinalidadeGrandeza(finalidade)) {
        return this.$t("subsidyMotorCatalog.purposes.magnitude");
      }
      return this.$t("subsidyMotorCatalog.purposes.general");
    },
  },
};
</script>
